import { RootState } from 'store/root-reducer';

import { Group } from './types';

export const getGroups = (state: RootState): Group[] | null => state.admin.usergroups.entities;
export const isGroupsLoading = (state: RootState): boolean => state.admin.usergroups.isLoading;
export const isUpdateGroupLoading = (state: RootState): boolean => state.admin.usergroups.isUpdatedGroupLoading;
export const isCreateGroupLoading = (state: RootState): boolean => state.admin.usergroups.isCreateGroupLoading;
